const routes = [
    {
        path: '/company/approvers/manage',
        name: 'CompanySystemApprovers',
        component: () => import('../../views/company/system_management/approvers/ModuleApprovers.vue')
    },
    {
        path: '/company/branches',
        name: 'CompanySystemBranches',
        component: () => import('../../views/company/system_management/branches/Branches.vue')
    },
    {
        path: '/company/branches/create',
        name: 'CompanySystemBranchesCreate',
        component: () => import('../../views/company/system_management/branches/CreateBranch.vue')
    },
    {
        path: '/company/blacklisted/suppliers',
        name: 'CompanySystemBlackListedSuppliers',
        component: () => import('../../views/company/system_management/suppliers/BlackListedSuppliers.vue')
    },
    {
        path: '/company/currencies',
        name: 'CompanySystemCurrencies',
        component: () => import('../../views/company/system_management/currencies/Currencies.vue')
    },
    {
        path: '/company/currencies/new',
        name: 'CompanySystemCurrenciesNew',
        component: () => import('../../views/company/system_management/currencies/NewCurrency.vue')
    },
    {
        path: '/company/currencies/edit/:id',
        name: 'CompanySystemCurrenciesEdit',
        component: () => import('../../views/company/system_management/currencies/EditCurrency.vue')
    },
    {
    path: '/company/category/types',
    name: 'CompanySystemCategoryTypes',
    component: () => import('../../views/company/system_management/category_types/List.vue')
  },
  {
    path: '/company/category/type/:id',
    name: 'CompanySystemCategoryType',
    component: () => import('../../views/company/system_management/category_types/Details.vue')
  },
  {
    path: '/company/category/types/create',
    name: 'CompanySystemCategoryTypeCreate',
    component: () => import('../../views/company/system_management/category_types/CreateCategoryType.vue')
  },
  {
    path: '/company/category/types/edit/:category_type_id',
    name: 'CompanySystemCategoryTypeEdit',
    component: () => import('../../views/company/system_management/category_types/EditCategoryType.vue')
  },
  {
    path: '/company/category/criteria/create/:category_type_id/:location_id',
    name: 'CompanySystemCategoryCriteriaCreate',
    component: () => import('../../views/company/system_management/category_types/CreateCategoryCriteria.vue')
  },
  {
    path: '/company/category/criteria/edit/:category_type_id/:criteria_id',
    name: 'CompanySystemCategoryCriteriaEdit',
    component: () => import('../../views/company/system_management/category_types/EditCategoryCriteria.vue')
  },
  {
    path: '/company/buyer/category/types',
    name: 'CompanySystemBuyerCategoryTypes',
    component: () => import('../../views/company/system_management/category_types/buyer_category_types/List.vue')
  },
  {
    path: '/company/category/type/:id/upload-buyers',
    name: 'CompanySystemCategoryTypeBuyers',
    component: () => import('../../views/company/system_management/category_types/buyer_category_types/UploadCategoryBuyers.vue')
  },
  {
    path: '/company/category/type/:id/buyer-upload-progress/:task_id',
    name: 'CompanySystemCategoryTypeBuyerUploadProgress',
    component: () => import('../../views/company/system_management/category_types/Progress.vue')
  },
  {
    path: '/company/category-type/sections/:categoryTypeId',
    name: 'CompanySystemCategoryTypeSections',
    component: () => import('../../views/company/system_management/category_types/criteria/SectionList.vue')
  },
  {
    path: '/company/category-type/questions/:categoryTypeId/:sectionId/',
    name: 'CompanySystemCategoryTypeQuestions',
    component: () => import('../../views/company/system_management/category_types/criteria/QuestionList.vue')
  },
  // new criteria set up
  {
    path: '/company/category-based/category/types',
    name: 'CompanyCategoryBasedCriteria',
    component: () => import('../../views/company/system_management/criteria_management/category_based/CategoryList.vue')
  },
  {
    path: '/company/general/criteria',
    name: 'CompanyGeneralCriteria',
    component: () => import('../../views/company/system_management/criteria_management/general/SectionList.vue')
  },
  {
    path: '/company/general/criteria/questions/:sectionId',
    name: 'CompanyGeneralCriteriaQuestions',
    component: () => import('../../views/company/system_management/criteria_management/general/QuestionList.vue')
  },
  {
    path: '/company/functions',
    name: 'CompanyFunctions',
    component: () => import('../../views/company/system_management/department/List.vue')
  },
  {
    path: '/company/functions/create',
    name: 'CompanyFunctionsCreate',
    component: () => import('../../views/company/system_management/department/Create.vue')
  },
  {
    path: '/company/functions/edit/:id',
    name: 'CompanyFunctionsEdit',
    component: () => import('../../views/company/system_management/department/Edit.vue')
  },
  {
    path: '/company/savings-per-category',
    name: 'CompanySavingsPerCategory',
    component: () => import('../../views/company/savings/Savings.vue')
  },
  {
    path: '/company/rfq-price-insights',
    name: 'CompanyRfqPriceInsights',
    component: () => import('../../views/company/dashboard/savings/RfqPriceInsight.vue')
  },
]

export default routes;